var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToggleSidebarOpen = function SvgToggleSidebarOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.625 4.463v1.875h18.75V4.463zm12.75 8.062H2.625V10.65h12.75zm6 6.188H2.625v-1.875h18.75zM17.587 8.025l3.788 3.788-3.788 3.787-1.33-1.33 2.474-2.457-2.456-2.456z"
  })));
};
export default SvgToggleSidebarOpen;